import { defineComponent as _defineComponent } from 'vue'
export interface Props extends BCard.Props {
  loading?: boolean;
  error?: boolean;
}


import { ref, computed, watch } from 'vue';
import { BCard } from 'bootstrap-vue';

import { delay } from '@tools/delay';

import Overlay from '@components/Overlay.vue';
import OverlayRenderIssue from '@components/OverlayRenderIssue.vue';
import Spinner from '@components/Spinner.vue';

declare module 'vue/types/vue' {
  export interface Vue {
    CardLoadable: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardLoadable' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { loading: boolean, error: boolean };

/**
 * `CardLoadable` component properties.
 */


const loadingStateActive = ref(false);
const transitionBufferCompleted = ref(false);

const classList = computed(() => {
  const items = ['card-loadable'];

  if (loadingStateActive.value) {
    items.push('loading');
  } else if (props.error) {
    items.push('error');
  }

  return items;
});

watch(() => props.loading, onLoadingStateChanged, { immediate: true });

function onLoadingStateChanged(value: boolean) {
  if (value) {
    void onLoadingStarted();
  } else {
    onLoadingFinished();
  }
}

async function onLoadingStarted() {
  if (loadingStateActive.value) return;

  loadingStateActive.value = true;
  transitionBufferCompleted.value = false;

  await delay(500);

  transitionBufferCompleted.value = true;

  loadingStateActive.value = props.loading ?? false;
}

function onLoadingFinished() {
  if (transitionBufferCompleted.value) {
    loadingStateActive.value = false;
  }
}

return { __sfc: true,props, loadingStateActive, transitionBufferCompleted, classList, onLoadingStateChanged, onLoadingStarted, onLoadingFinished, BCard, Overlay, OverlayRenderIssue, Spinner }
}

})